import Container from 'typedi';
import { UserContextBase } from './user-context-base';
import {
    LocalSimpleStoreService,
    SessionSimpleStoreService,
} from '../storage/implementations/simple-store';

export class UserContext extends UserContextBase {
    private readonly _localSimpleStoreService: LocalSimpleStoreService;
    private readonly _sessionSimpleStoreService: SessionSimpleStoreService;

    constructor() {
        super();
        this._localSimpleStoreService = Container.get(LocalSimpleStoreService);
        this._sessionSimpleStoreService = Container.get(SessionSimpleStoreService);
    }

    public refresh = (): void => {
        this._logContext('[REFRESH] - Old context');
        const batchNumber = this._window.pageContextManager.getUserData().batchNumber;
        this._batchNumber = batchNumber || undefined;
        this.setAuthorizationToken();
        this._logContext('[REFRESH] - New context');
    };

    public setAuthorizationToken = (): void => {
        //TODO: Remove the use of sessionSimpleStoreService when remove SINGLE_TAB_LOGGED_IN
        let authorizationData = this._localSimpleStoreService.get('authorizationData');
        if (!authorizationData)
            authorizationData = this._sessionSimpleStoreService.get('authorizationData');
        const parsedAuthorizationData = authorizationData && JSON.parse(authorizationData);
        this._authorizationToken = parsedAuthorizationData?.token;
    };

    private _logContext = (message: string) => {
        const currentContext = {
            IsAuthenticated: this.IsAuthenticated,
            BatchNumber: this.BatchNumber,
        };
        this._logger.debug(`${message}: ${JSON.stringify(currentContext)}`);
    };
}
